import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IPage } from "InterfacesTypes/interfaces";

export interface ICurrentNewsState {
  currentNews: IPage[];
  loading: boolean;
  error: string | null;
}

const initialState: ICurrentNewsState = {
  currentNews: [],
  loading: false,
  error: null,
};

export const fetchCurrentNews = createAction("currentNews/fetchCurrentNews");

export const currentNewsSlice = createSlice({
  name: "currentNews",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IPage[]>) {
      state.loading = false;
      state.currentNews = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setCurrentNews(state, action: PayloadAction<IPage[]>) {
      state.currentNews = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setCurrentNews } =
  currentNewsSlice.actions;

export const currentNewsReducer = currentNewsSlice.reducer;
